import { ServiceBase } from '../ServiceBase';
import { INVOICE } from '../../../utils/ServiceUtils';
import { IListInvoiceRequest } from './requests/ListInvoiceRequest';
import { ListInvoiceResponse } from './responses/ListInvoiceResponse';
import { IListInvoiceStatusRequest } from './requests/ListInvoiceStatusRequest';
import { ListInvoiceStatusResponse } from './responses/ListInvoiceStatusResponse';
import { ISumInvoiceRequest } from './requests/SumInvoiceRequest';
import { SumInvoiceResponse } from './responses/SumInvoiceResponse';
import { ICreateInvoiceRequest } from './requests/CreateInvoiceRequest';
import { CreateInvoiceResponse } from './responses/CreateInvoiceResponse';
import { IUpdateInvoiceRequest } from './requests/UpdateInvoiceRequest';
import { UpdateInvoiceResponse } from './responses/UpdateInvoiceResponse';
import { IDeleteInvoiceRequest } from './requests/DeleteInvoiceRequest';
import { DeleteInvoiceResponse } from './responses/DeleteInvoiceResponse';
import { ICreateInvoicesFromItemsRequest } from './requests/CreateInvoicesFromItemsRequest';
import { CreateInvoicesFromItemsResponse } from './responses/CreateInvoicesFromItemsResponse';
import { IGetInvoiceRequest } from './requests/GetInvoiceRequest';
import { GetInvoiceResponse } from './responses/GetInvoiceResponse';
import { IListPaymentMethodRequest } from './requests/ListPaymentMethodRequest';
import { ListPaymentMethodResponse } from './responses/ListPaymentMethodResponse';
import { IListTransactionRequest } from './requests/ListTransactionRequest';
import { ListTransactionResponse } from './responses/ListTransactionResponse';

export interface IInvoiceService {
    listInvoices(request: IListInvoiceRequest): Promise<ListInvoiceResponse>;
    listInvoiceStatus(request: IListInvoiceStatusRequest): Promise<ListInvoiceStatusResponse>;
    sumInvoice(request: ISumInvoiceRequest): Promise<SumInvoiceResponse>;
    createInvoice(request: ICreateInvoiceRequest): Promise<CreateInvoiceResponse>;
    updateInvoice(request: IUpdateInvoiceRequest): Promise<UpdateInvoiceResponse>;
    deleteInvoice(request: IDeleteInvoiceRequest): Promise<DeleteInvoiceResponse>;
    createInvoicesFromItems(request: ICreateInvoicesFromItemsRequest): Promise<CreateInvoicesFromItemsResponse>;
    getInvoice(request: IGetInvoiceRequest): Promise<GetInvoiceResponse>;
    listPaymentMethod(request: IListPaymentMethodRequest): Promise<ListPaymentMethodResponse>;
    listTransaction(request: IListTransactionRequest): Promise<ListTransactionResponse>;
}

export class InvoiceService extends ServiceBase implements IInvoiceService {
    public async listInvoices(request: IListInvoiceRequest): Promise<ListInvoiceResponse> {
        let response: any = null;
        try {
            let tmp_response = (await this.makeCall(request.toXml(), INVOICE.listInvoice, request.cancelSource));
            response = tmp_response.data;
            await this.updateCache(INVOICE.listInvoice, request.toXml(), response);
        } catch (error: any) {
            response = await this.getFromCache(INVOICE.listInvoice, request.toXml());
        }
        var parsedResponse = super.sendResponse2(response, ['INVOICE']).ListInvoiceResponse as ListInvoiceResponse;
        if (!super._checkErrors(parsedResponse)) {

        }
        return parsedResponse;
    }

    public async listInvoiceStatus(request: IListInvoiceStatusRequest): Promise<ListInvoiceStatusResponse> {
        let response: any = null;
        try {
            let tmp_response = (await this.makeCall(request.toXml(), INVOICE.listInvoiceStatus, request.cancelSource));
            response = tmp_response.data;
            await this.updateCache(INVOICE.listInvoiceStatus, request.toXml(), response);
        } catch (error: any) {
            response = await this.getFromCache(INVOICE.listInvoiceStatus, request.toXml());
        }

        var parsedResponse = super.sendResponse2(response, ['ITEM']).ListInvoiceStatusResponse as ListInvoiceStatusResponse;
        if (!super._checkErrors(parsedResponse)) {

        };
        return parsedResponse;
    }

    public async sumInvoice(request: ISumInvoiceRequest): Promise<SumInvoiceResponse> {
        let response: any = null;
        try {
            let tmp_response = (await this.makeCall(request.toXml(), INVOICE.sumInvoice, request.cancelSource));
            response = tmp_response.data;
            await this.updateCache(INVOICE.sumInvoice, request.toXml(), response);
        } catch (error: any) {
            response = await this.getFromCache(INVOICE.sumInvoice, request.toXml());
        }

        var parsedResponse = super.sendResponse2(response, ['SUMINVOICE', 'SUMSTATES']).SumInvoiceResponse as SumInvoiceResponse;
        if (!super._checkErrors(parsedResponse)) {

        };
        return parsedResponse;
    }

    public async createInvoice(request: ICreateInvoiceRequest): Promise<CreateInvoiceResponse> {
        let response: any = null;
        try {
            let tmp_response = (await this.makeCall(request.toXml(), INVOICE.createInvoice, request.cancelSource));
            response = tmp_response.data;
            await this.updateCache(INVOICE.createInvoice, request.toXml(), response);
        } catch (error: any) {
            response = await this.getFromCache(INVOICE.createInvoice, request.toXml());
        }

        var parsedResponse = super.sendResponse2(response).CreateInvoiceResponse as CreateInvoiceResponse;
        if (!super._checkErrors(parsedResponse)) {

        };
        return parsedResponse;
    }

    public async updateInvoice(request: IUpdateInvoiceRequest): Promise<UpdateInvoiceResponse> {
        let response: any = null;
        try {
            let tmp_response = (await this.makeCall(request.toXml(), INVOICE.updateInvoice, request.cancelSource));
            response = tmp_response.data;
            await this.updateCache(INVOICE.updateInvoice, request.toXml(), response);
        } catch (error: any) {
            response = await this.getFromCache(INVOICE.updateInvoice, request.toXml());
        }

        var parsedResponse = super.sendResponse2(response).UpdateInvoiceResponse as UpdateInvoiceResponse;
        if (!super._checkErrors(parsedResponse)) {

        };
        return parsedResponse;
    }

    public async deleteInvoice(request: IDeleteInvoiceRequest): Promise<DeleteInvoiceResponse> {
        let response: any = null;
        try {
            let tmp_response = (await this.makeCall(request.toXml(), INVOICE.deleteInvoice, request.cancelSource));
            response = tmp_response.data;
            await this.updateCache(INVOICE.deleteInvoice, request.toXml(), response);
        } catch (error: any) {
            response = await this.getFromCache(INVOICE.deleteInvoice, request.toXml());
        }

        var parsedResponse = super.sendResponse2(response).DeleteInvoiceResponse as DeleteInvoiceResponse;
        if (!super._checkErrors(parsedResponse)) {

        };
        return parsedResponse;
    }

    public async createInvoicesFromItems(request: ICreateInvoicesFromItemsRequest): Promise<CreateInvoicesFromItemsResponse> {
        let response: any = null;
        try {
            let tmp_response = (await this.makeCall(request.toXml(), INVOICE.createInvoicesFromItems, request.cancelSource));
            response = tmp_response.data;
            await this.updateCache(INVOICE.createInvoicesFromItems, request.toXml(), response);
        } catch (error: any) {
            response = await this.getFromCache(INVOICE.createInvoicesFromItems, request.toXml());
        }
        var parsedResponse = super.sendResponse2(response).CreateInvoicesFromItemsResponse as CreateInvoicesFromItemsResponse;
        if (!super._checkErrors(parsedResponse)) {

        };
        return parsedResponse;
    }

    public async getInvoice(request: IGetInvoiceRequest): Promise<GetInvoiceResponse> {
        let response: any = null;
        try {
            let tmp_response = (await this.makeCall(request.toXml(), INVOICE.getInvoice, request.cancelSource));
            response = tmp_response.data;
            await this.updateCache(INVOICE.getInvoice, request.toXml(), response);
        } catch (error: any) {
            response = await this.getFromCache(INVOICE.getInvoice, request.toXml());
        }

        var parsedResponse = super.sendResponse2(response).GetInvoiceResponse as GetInvoiceResponse;
        if (!super._checkErrors(parsedResponse)) {

        };
        return parsedResponse;
    }

    public async listPaymentMethod(request: IListPaymentMethodRequest): Promise<ListPaymentMethodResponse> {
        let response: any = null;
        try {
            let tmp_response = (await this.makeCall(request.toXml(), INVOICE.listPaymentMethod, request.cancelSource));
            response = tmp_response.data;
            await this.updateCache(INVOICE.listPaymentMethod, request.toXml(), response);
        } catch (error: any) {
            response = await this.getFromCache(INVOICE.listPaymentMethod, request.toXml());
        }

        var parsedResponse = super.sendResponse2(response, ['ITEM']).ListPaymentMethodResponse as ListPaymentMethodResponse;
        if (!super._checkErrors(parsedResponse)) {

        };
        return parsedResponse;
    }

    public async listTransaction(request: IListTransactionRequest): Promise<ListTransactionResponse> {
        let response: any = null;
        try {
            let tmp_response = (await this.makeCall(request.toXml(), INVOICE.listTransaction, request.cancelSource));
            response = tmp_response.data;
            await this.updateCache(INVOICE.listTransaction, request.toXml(), response);
        } catch (error: any) {
            response = await this.getFromCache(INVOICE.listTransaction, request.toXml());
        }
        var parsedResponse = super.sendResponse2(response, ['TRANSACTION']).ListTransactionResponse as ListTransactionResponse;
        if (!super._checkErrors(parsedResponse)) {

        };
        return parsedResponse;
    }
}
